<div class="result" *ngIf="fnolRequest">
  <div class="item-header">
    <div class="label-value simple" [title]="'fnol-request-side-bar.labels.simple_claim' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.SIMPLE_CLAIM)"></div>
    <div class="label-value multiple" [title]="'fnol-request-side-bar.labels.multiple_claims' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.MULTIPLE_CLAIMS)"></div>
    <div class="label-value waiting" [title]="'fnol-request-side-bar.labels.waiting' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.WAITING)"></div>
    <div class="label-value simpego" [title]="'fnol-request-side-bar.labels.simpego' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.SIMPEGO)"></div>
    <div class="label-value agent" [title]="'fnol-request-side-bar.labels.agent' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.AGENT)"></div>
    <div class="label-value potential-duplicate" [title]="'fnol-request-side-bar.labels.potential_duplicate' | translate" [class.not-checked]="!fnolRequest.taskLabels.get(TasksLabels.POTENTIAL_DUPLICATE)"></div>
  </div>

  <div class="list-item">
    <div class="list-value" [class.pointer]="fnolRequest.hasUnclosedTasks" (click)="fnolRequest.hasUnclosedTasks && openTasksList(fnolRequest)">
      <mat-icon color="primary" *ngIf="fnolRequest.hasUnclosedTasks">pending_actions</mat-icon>
    </div>

    <div class="list-value">
      <mat-icon color="primary" *ngIf="fnolRequest.hasReservedClaims">attach_money</mat-icon>
    </div>

    <div class="list-value priority-circle">
      <mat-icon *ngIf="fnolRequest.priority===1">priority_high</mat-icon>
    </div>
    <div class="list-value">{{ fnolRequest.notificationDate | date: 'dd MMM yyyy, HH:mm' }}</div>
    <div class="list-value">{{ fnolRequest.fnolFirstName }}</div>
    <div class="list-value">{{ fnolRequest.fnolLastName }}</div>
    <div class="list-value">{{ fnolRequest.fnolEmail }}</div>
    <div class="list-value">{{ fnolRequest.fnolPetName }}</div>
    <div class="list-value status">{{ fnolRequest.statusString | translate }}</div>
    <div class="list-value assignee"
         *ngIf="fnolRequest.assigneeUser; else noAssignee"
         [title]="fnolRequest.assigneeUser.email">
      <div class="assignee-circle">{{ fnolRequest.assigneeUser.firstname[0].toUpperCase() }}</div>
      {{ fnolRequest.assigneeUser.firstname }}
    </div>

    <ng-template #noAssignee>
      <div class="list-value assignee">-</div>
    </ng-template>

    <div class="list-value action">
      <button mat-icon-button color="primary" (click)="openSideDetails(fnolRequest)">
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
      <a color="primary" mat-raised-button [routerLink]="['/platform', 'fnol-request', fnolRequest.id]">
        {{ 'fnol-request-list.button-details' | translate }}
      </a>
    </div>
  </div>
</div>
